import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LoadingFinishModal from '../../../components/LoadingFinishModal';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { loadContractsV2 } from '../../../store/ducks/fabrication-contracts/actions';
import { updateFabricationPurchaseOrderSettings } from '../../../store/ducks/fabrication-purchase-order/actions';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { EPurchaseRoutes } from '../purchase.routes';
import FabricationTabs from './FabricationTabs';
import FabricationRoutes, { EFabricationRoutes } from './fabrication.routes';
import { Container, ContainerFacelift } from './styles';

const Fabrication: React.FC = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const history = useHistory();

  const userState = useSelector((state: ApplicationState) => state.user);
  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );
  const fabricationProjectsState = useSelector(
    (appState: ApplicationState) => appState.fabricationProjects
  );

  const [constructionIdentificationState, setConstructionIdentificationState] =
    useState(fabricationPurchaseOrder.constructionIdentification);
  const [detailingProjectState, setDetailingProjectState] = useState(
    fabricationPurchaseOrder.detailingProject
  );
  const [extraItensState, setExtraItensState] = useState(
    fabricationPurchaseOrder.extraItens
  );

  const contractsState = useSelector(
    (appState: ApplicationState) => appState.fabricationContracts
  );

  const getBreadcrumbs = () => {
    return [
      { name: 'Comprar', url: ERoutes.PURCHASE },
      {
        name: 'Solicitação de Corte e dobra',
        url: `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
      },
      ...(pathname.includes(EFabricationRoutes.LAST_ORDERS)
        ? [
            {
              name: 'Histórico de pedidos',
              url: ''
            }
          ]
        : [])
    ];
  };

  const loadContractsIfNeed = () => {
    if (
      !userState.isManager &&
      contractsState.contracts === undefined &&
      !contractsState.loading &&
      !contractsState.error
    ) {
      dispatch(loadContractsV2());
    }
  };

  useEffect(() => {
    loadContractsIfNeed();
  });

  const updateFabricationOrderState = () => {
    if (
      !pathname.includes(EFabricationRoutes.SUCCESS) &&
      !pathname.includes(EFabricationRoutes.CHECKOUT)
    ) {
      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseOrder,
          constructionIdentification: constructionIdentificationState,
          detailingProject: detailingProjectState,
          extraItens: extraItensState
        })
      );
    }
  };

  useEffect(() => {
    if (
      fabricationPurchaseOrder.constructionIdentification.comingFromBuyAgain
    ) {
      if (
        fabricationPurchaseOrder.constructionIdentification !==
        constructionIdentificationState
      ) {
        setConstructionIdentificationState(
          fabricationPurchaseOrder.constructionIdentification
        );
      }
      if (fabricationPurchaseOrder.detailingProject !== detailingProjectState) {
        setDetailingProjectState(fabricationPurchaseOrder.detailingProject);
      }
      if (fabricationPurchaseOrder.extraItens !== extraItensState) {
        setExtraItensState(fabricationPurchaseOrder.extraItens);
      }
    }
  }, [
    fabricationPurchaseOrder.constructionIdentification,
    fabricationPurchaseOrder.detailingProject
  ]);

  // dispara ação de atualizar estado quando trocar de página
  useEffect(() => {
    const unlisten = history.listen(() => {
      updateFabricationOrderState();
    });

    return () => {
      unlisten();
    };
  });

  return (
    <>
      <ContainerFacelift
        isEmitter={userState.searchCustomerType === ECustomerTypeView.EMITTER}
      >
        {userState.searchCustomerType === ECustomerTypeView.EMITTER && (
          <Breadcrumbs
            breadcrumbItems={getBreadcrumbs()}
            onClick={(e) => {
              history.push(e);
            }}
          />
        )}

        {!pathname.includes(EFabricationRoutes.LAST_ORDERS) && (
          <div>
            <Title level={1}>Solicitação de corte e dobra</Title>
          </div>
        )}

        {!pathname.includes(EFabricationRoutes.LAST_ORDERS) && (
          <FabricationTabs />
        )}
      </ContainerFacelift>
      <Container>
        {fabricationPurchaseOrder.finishOrderLoading && (
          <LoadingFinishModal message="Aguarde, seu pedido está sendo enviado..." />
        )}

        <FabricationRoutes
          fabricationPurchaseOrder={fabricationPurchaseOrder}
          fabricationProjectsState={fabricationProjectsState}
          contractsState={contractsState}
          constructionIdentificationState={constructionIdentificationState}
          setConstructionIdentificationState={
            setConstructionIdentificationState
          }
          detailingProjectState={detailingProjectState}
          setDetailingProjectState={setDetailingProjectState}
          extraItensState={extraItensState}
          setExtraItensState={setExtraItensState}
        />
      </Container>
    </>
  );
};

export default Fabrication;
